import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import { fileDownload } from './file-download.async'
import { downloadBase64 } from 'src/utils/downloadBase64'

const initialState = {
  fileDownloadLoader: false,
  complianceReport: {},
}

const FileDownloadReducer = createSlice({
  name: 'FileDownloadReducer',
  initialState,
  reducers: {
    emptyFileDownloadReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(fileDownload.pending), (state) => {
      state.fileDownloadLoader = true
    })
    builder.addMatcher(isAnyOf(fileDownload.fulfilled), (state, action) => {
      state.fileDownloadLoader = false
      state.complianceReport = action.payload.data.fileData
      downloadBase64(action?.payload?.data?.fileData, 'compliance_risk_summary', 'application/pdf')
    })
    builder.addMatcher(isAnyOf(fileDownload.rejected), (state) => {
      state.fileDownloadLoader = false
    })
  },
})

export const { emptyFileDownloadReducer } = FileDownloadReducer.actions
export default FileDownloadReducer.reducer
